import { API_ROUTES } from '@memorai/routes';
import type { DeleteNoteResponse, FetchNotesFilters, Note } from '@memorai/types';
import { apiFetch } from './client.js';

export type { DeleteNoteResponse, FetchNotesFilters, Note, NoteType } from '@memorai/types';

export async function fetchNotes(
    limit = 20,
    offset = 0,
    filters?: FetchNotesFilters,
): Promise<Note[]> {
    const params = new URLSearchParams({
        limit: limit.toString(),
        offset: offset.toString(),
    });

    if (filters?.query) params.append('query', filters.query);
    if (filters?.categoryIds && filters.categoryIds.length > 0) {
        params.append('categoryIds', filters.categoryIds.join(','));
    }
    if (filters?.createdAtFrom) params.append('createdAtFrom', filters.createdAtFrom);
    if (filters?.createdAtBefore) params.append('createdAtBefore', filters.createdAtBefore);
    if (filters?.uncategorized) params.append('uncategorized', 'true');
    if (filters?.isArchived !== undefined) params.append('isArchived', filters.isArchived.toString());

    return apiFetch<Note[]>(`${API_ROUTES.NOTES}?${params.toString()}`);
}

export async function fetchNote(id: string): Promise<Note> {
    return apiFetch<Note>(API_ROUTES.NOTE(id));
}

export async function updateNote(id: string, updates: Partial<Note>): Promise<Note> {
    return apiFetch<Note>(API_ROUTES.NOTE(id), {
        method: 'PATCH',
        body: JSON.stringify(updates),
    });
}

export async function deleteNote(id: string): Promise<DeleteNoteResponse> {
    return apiFetch<DeleteNoteResponse>(API_ROUTES.NOTE(id), {
        method: 'DELETE',
    });
}
